// extracted by mini-css-extract-plugin
export var badge = "DateBadge-module--badge--749f9";
export var badgeWrapper = "DateBadge-module--badgeWrapper--af9c8";
export var center = "DateBadge-module--center--04bdc";
export var dash = "DateBadge-module--dash--0fc11";
export var date = "DateBadge-module--date--fc988";
export var isPastEvent = "DateBadge-module--isPastEvent--89bd5";
export var left = "DateBadge-module--left--7663f";
export var longBadge = "DateBadge-module--longBadge--4bac0";
export var month = "DateBadge-module--month--03b13";